import { useMutation } from "@apollo/client";
import { CreateDraftOrderDocument } from "../../gql/generated/graphql";

export const useCreateDraftOrder = () => {
  const [createDraftOrder, { loading }] = useMutation(CreateDraftOrderDocument);

  return {
    createDraftOrder,
    loading,
  };
};
